import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

function AdminDashboard() {
  const { t, i18n } = useTranslation();
  const [term, setTerm] = useState(null);
  const [released, setReleased] = useState(false);
  const changeLanguage = (lang) => {

  i18n.changeLanguage(lang);

  localStorage.setItem(
    "language",
    lang
  );
};

  // NEW
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [promotionAverage, setPromotionAverage] = useState(10);
  const [promotionResult, setPromotionResult] = useState(null);
  const [promoting, setPromoting] = useState(false);

  const token = localStorage.getItem("access");

  useEffect(() => {
    fetchTerm();
    fetchClasses();
  }, [token]);

  // =====================================================
  // FETCH TERM
  // =====================================================

  const fetchTerm = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/active-terms/",
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      );

      if (res.data.length > 0) {

        setTerm(
          res.data[0].name +
          " - " +
          res.data[0].session__name
        );

        setReleased(
          res.data[0].results_released
        );
      }

    } catch (err) {
      console.error(err);
    }
  };

  // =====================================================
  // FETCH CLASSES
  // =====================================================

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/classes/",
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      );

      setClasses(res.data);

    } catch (err) {
      console.error(err);
    }
  };

  // =====================================================
  // TOGGLE RESULT RELEASE
  // =====================================================

  const toggleRelease = async () => {

    try {

      const res = await axios.post(
        "https://api.eduskot.com/api/results/toggle-results-release/",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      );

      setReleased(
        res.data.results_released
      );

    } catch (err) {

      console.error(err);

      alert("Failed to update result release.");
    }
  };

  // =====================================================
  // PROMOTE STUDENTS
  // =====================================================

  const promoteStudents = async () => {

    if (!selectedClass) {
      alert("Please select a class.");
      return;
    }

    try {

      setPromoting(true);

      const res = await axios.post(
        "https://api.eduskot.com/api/academics/promote-students/",
        {
          class_id: selectedClass,
          promotion_average: promotionAverage,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      );

      setPromotionResult(res.data);

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.error ||
        "Promotion failed."
      );

    } finally {

      setPromoting(false);
    }
  };

  return (
    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.topBar}>

        <div>

          <h1 style={styles.title}>
            {t("adminDashboard")}
          </h1>

          <p style={styles.subtitle}>
            {t("schoolManagement")}
          </p>

        </div>

        <div
          style={{
            display:"flex",
            gap:"10px",
            alignItems:"center"
          }}
        >

          <button
            style={styles.languageBtn}
            onClick={() =>
              changeLanguage(
                i18n.language === "en"
                  ? "fr"
                  : "en"
              )
            }
          >
            {i18n.language === "en"
              ? "🇫🇷 FR"
              : "🇬🇧 EN"}
          </button>

          <a
  href="https://api.eduskot.com/admin/"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.adminShortcutBtn}
>
  ⚙️ Config

</a>

          <button
            style={styles.logoutTopBtn}
            onClick={() => {

              localStorage.clear();

              window.location.href = "/";
            }}
          >
            {t("logout")}
          </button>

        </div>

      </div>

      {/* RESULT STATUS */}

      <div style={styles.statusCard}>

        <div>

          <h3 style={{ marginBottom:"6px" }}>
            {t("currentTerm")}
          </h3>

          <p style={{ color:"#64748b" }}>
            {term || "Loading..."}
          </p>

        </div>

        <div
          style={{
            display:"flex",
            gap:"10px",
            alignItems:"center"
          }}
        >

          <div
            style={{
              ...styles.statusBadge,
              background:
                released
                  ? "#16a34a"
                  : "#ef4444",
            }}
          >
            {
              released
                ? t("resultsReleased")
                : t("resultsNotReleased")   
            }
          </div>

          <button
            style={{
              ...styles.releaseBtn,
              background:
                released
                  ? "#ef4444"
                  : "#16a34a"
            }}
            onClick={toggleRelease}
          >
            {
              released
                ? t("lockResults")
                : t("releaseResults")
            }
          </button>

        </div>

      </div>



      {/* COMMUNICATION CENTER */}

      <div style={styles.communicationCard}>

        {/* LEFT SIDE */}

        <div style={styles.communicationInfo}>

          <h2 style={styles.communicationTitle}>
            {t("communicationCenter")}
          </h2>

          <p style={styles.communicationText}>
            {t("communicationText")}
          </p>

        </div>

        {/* RIGHT SIDE */}

        <div style={styles.communicationActions}>

          {/* SEND REPORTS */}

          <button
            style={styles.communicationPrimaryBtn}
            onClick={() =>
              (
                window.location.href =
                "/admin/send-report-cards"
              )
            }
          >
            {t("sendReportCards")}
          </button>

          {/* SEND MESSAGES */}

          <button
            style={styles.communicationSecondaryBtn}
            onClick={() =>
              (
                window.location.href =
                "/admin/send-parent-messages"
              )
            }
          >
            {t("sendParentMessages")}
          </button>

        </div>

      </div>





      {/* MAIN GRID */}

      <div style={styles.grid}>

        {/* REPORTS */}

        <div style={styles.card}>

          <h3 style={styles.cardTitle}>
            {t("reportCards")}
          </h3>

          <p style={styles.cardText}>
            {t("reportCardsText")}
          </p>

          <button
            style={styles.primaryBtn}
            onClick={() =>
              (window.location.href =
                "/admin/reports")
            }
          >
            {t("openReportGenerator")}
          </button>

        </div>

        {/* FEES */}

<div style={styles.card}>

  <h3 style={styles.cardTitle}>
    {t("feeClearance")}
  </h3>

  <p style={styles.cardText}>
    {t("feeClearanceText")}
  </p>

  <button
    style={styles.secondaryBtn}
    onClick={() =>
      (window.location.href =
        "/admin/fees")
    }
  >
    {t("manageStudentFees")}
  </button>

  <button
    style={{
      padding:"12px",
      background:"#694702",
      color:"white",
      border:"none",
      borderRadius:"10px",
      fontWeight:"600",
      cursor:"pointer",
      marginTop:"8px"
    }}
    onClick={() =>
      (
        window.location.href =
        "/admin/installments"
      )
    }
  >
    {t("manageInstallments")}
  </button>

</div>

        {/* PROMOTION */}

        <div style={styles.card}>

          <h3 style={styles.cardTitle}>
            {t("promoteStudents")}
          </h3>

          <p style={styles.cardText}>
            {t("promoteStudentsText")}
          </p>

          <select
            value={selectedClass}
            onChange={(e) =>
              setSelectedClass(e.target.value)
            }
            style={styles.select}
          >

            <option value="">
              {t("selectClass")}
            </option>

            {classes.map((c) => (
              <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>
            ))}

          </select>

          <input
            type="number"
            value={promotionAverage}
            onChange={(e) =>
              setPromotionAverage(
                e.target.value
              )
            }
            style={styles.input}
            placeholder={t("promotionAverage")}
          />

          <button
            style={styles.promoteBtn}
            onClick={promoteStudents}
            disabled={promoting}
          >
            {
              promoting
                ? t("promoting")
                : t("promoteStudents")
            }
          </button>

        </div>

        {/* DOCUMENT GENERATION */}

        <div style={styles.card}>

          <h3 style={styles.cardTitle}>
            {t("documents")}
          </h3>

          <p style={styles.cardText}>
            {t("documentsText")}
          </p>

          <button
            style={styles.primaryBtn}
            onClick={() =>
              (window.location.href =
                "/admin/id-cards")
            }
          >
            {t("generateSchoolId")}
          </button>

          <button
            style={styles.secondaryBtn}
            onClick={() =>
              (window.location.href =
                "/admin/class-lists")
            }
          >
            {t("generateClassList")}
          </button>

          <button
            style={styles.analyticsBtn}
            onClick={() =>
              (window.location.href =
                "/admin/class-analytics")
            }
          >
            {t("classAnalytics")}
          </button>

        </div>

      </div>

      {/* PROMOTION RESULTS */}

      {promotionResult && (

        <div style={styles.resultCard}>

          <h2 style={{ marginBottom:"15px" }}>
            {t("promotionResults")}
          </h2>

          <p>
            Total Students:
            {" "}
            {promotionResult.total_students}
          </p>

          <p>
            Promoted:
            {" "}
            {promotionResult.promoted_count}
          </p>

          <p>
            Repeated:
            {" "}
            {promotionResult.repeated_count}
          </p>

          <p>
            Promotion Average:
            {" "}
            {promotionResult.promotion_average}
          </p>

        </div>
      )}

    </div>
  );
}

const styles = {

  page:{
    padding: window.innerWidth < 768 ? "7px" : "20px",
    fontFamily:"Inter, Segoe UI, sans-serif",
    background:"linear-gradient(135deg,#f1f5f9,#e2e8f0)",
    minHeight:"100vh"
  },



  communicationCard:{
  background:"white",
  padding:"24px",
  borderRadius:"16px",
  boxShadow:"0 10px 30px rgba(0,0,0,0.06)",
  marginBottom:"30px",
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  flexWrap:"wrap",
  gap:"20px"
},


adminShortcutBtn:{
  padding:"12px 18px",
  background:"linear-gradient(135deg,#2563eb,#3b82f6)",
  color:"white",
  border:"none",
  borderRadius:"10px",
  fontWeight:"700",
  cursor:"pointer",
  textDecoration:"none",
  display:"inline-flex",
  alignItems:"center",
  justifyContent:"center",
  boxShadow:"0 6px 15px rgba(16, 26, 89, 0.18)",
  transition:"all .3s ease"
},

communicationInfo:{
  flex:"1",
  minWidth:"260px"
},

communicationTitle:{
  marginBottom:"8px",
  fontSize:"24px",
  fontWeight:"700",
  color:"#0f172a"
},

communicationText:{
  color:"#64748b",
  fontSize:"15px",
  lineHeight:"1.6"
},

communicationActions:{
  display:"flex",
  gap:"15px",
  flexWrap:"wrap"
},



communicationPrimaryBtn:{
  padding:"14px 22px",
  background:"#2563eb",
  color:"white",
  border:"none",
  borderRadius:"12px",
  fontWeight:"700",
  cursor:"pointer",
  minWidth:"220px"
},

communicationSecondaryBtn:{
  padding:"14px 22px",
  background:"#7c3aed",
  color:"white",
  border:"none",
  borderRadius:"12px",
  fontWeight:"700",
  cursor:"pointer",
  minWidth:"220px"
},





  topBar:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"flex-start",
    marginBottom:"30px",
    flexWrap:"wrap",
    gap:"20px"
  },

  title:{
    marginBottom:"6px",
    fontSize:"28px"
  },

  subtitle:{
    color:"#64748b"
  },

  logoutTopBtn:{
    padding:"12px 18px",
    background:"#ef4444",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer"
  },

  statusCard:{
    background:"white",
    padding:"20px",
    borderRadius:"14px",
    boxShadow:"0 10px 30px rgba(0,0,0,0.06)",
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom:"30px",
    flexWrap:"wrap"
  },

  statusBadge:{
    padding:"10px 16px",
    borderRadius:"20px",
    color:"white",
    fontWeight:"600",
    fontSize:"14px"
  },

  releaseBtn:{
    padding:"10px 16px",
    border:"none",
    borderRadius:"8px",
    color:"white",
    fontWeight:"600",
    cursor:"pointer"
  },

  grid:{
    display:"grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(260px,1fr))",
    gap:"20px",
    marginTop:"20px"
  },

  card:{
    background:"white",
    padding:"24px",
    borderRadius:"14px",
    boxShadow:"0 10px 30px rgba(0,0,0,0.06)",
    display:"flex",
    flexDirection:"column",
    gap:"12px"
  },

  cardTitle:{
    marginBottom:"8px"
  },

  cardText:{
    fontSize:"14px",
    color:"#64748b"
  },

  primaryBtn:{
    padding:"12px",
    background:"#2563eb",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer"
  },

  secondaryBtn:{
    padding:"12px",
    background:"#16a34a",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer"
  },

  promoteBtn:{
    padding:"12px",
    background:"#7c3aed",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer"
  },

  analyticsBtn:{
  padding:"12px",
  background:"#0f172a",
  color:"white",
  border:"none",
  borderRadius:"10px",
  fontWeight:"600",
  cursor:"pointer"
},

  select:{
    padding:"12px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  languageBtn:{
    padding:"12px 18px",
    background:"#25633b",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer"
  },

  input:{
    padding:"12px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  resultCard:{
    marginTop:"30px",
    background:"white",
    padding:"25px",
    borderRadius:"14px",
    boxShadow:"0 10px 30px rgba(0,0,0,0.06)"
  }
};

export default AdminDashboard;